import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function NoDataToBeShown() {
  const { t } = useTranslation();

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <Typography variant="h4" alignItems="center" justifyContent="center">
        {t("No data to be shown.")}
      </Typography>
    </Box>
  );
}
